import React, { useState } from "react";
import "./css/HealthInsuranceCalculator.css";

const HealthInsuranceCalculator = () => {
  const [age, setAge] = useState(30);
  const [coverageAmount, setCoverageAmount] = useState(250000);
  const [planType, setPlanType] = useState("Standard");

  const RiderCard = () => {
    return (
      <div className="rider-container">
        <h3 className="rider-title">Riders</h3>
        <p className="rider-description">
          You should get these additional benefits to enhance your current plan
        </p>
  
        <div className="rider-card">
          <div className="rider-info">
            <div className="rider-header">
              <span className="rider-name">PED BuyBack</span>
              <span className="must-have-badge">Must Have</span>
            </div>
            <p className="rider-subtitle">
              Reduce your existing illness coverage waiting period by 2 years
            </p>
          </div>
  
          <div className="rider-premium">
            <span className="premium-amount">₹1,573</span>
            <button className="add-button">+ Add</button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="preview-container premium-calc-card">
        <div className="embed-root">
          <div className="widget-background">
            <div className="widget-content">
              <div className="widget-layout">
                {/* Form Container */}
                <form className="form-container">
                  <div className="form-field">
                    <label className="slider-label">Age</label>
                    <input
                      type="number"
                      value={age}
                      onChange={(e) => setAge(e.target.value)}
                      className="text-input"
                      min="18"
                      max="65"
                    />
                    <input
                      type="range"
                      min="18"
                      max="65"
                      value={age}
                      onChange={(e) => setAge(e.target.value)}
                      className="slider-container"
                    />
                    <div className="slider-labels">
                      <span>18</span>
                      <span>65</span>
                    </div>
                    <div className="form-hint">Select your age</div>
                  </div>

                  <div className="form-field">
                    <label className="slider-label">Coverage Amount</label>
                    <input
                      type="text"
                      value={`₹${coverageAmount.toLocaleString()}`}
                      onChange={(e) => setCoverageAmount(parseInt(e.target.value.replace(/[^\d]/g, "")))}
                      className="text-input"
                    />
                    <input
                      type="range"
                      min="50000"
                      max="1000000"
                      step="5000"
                      value={coverageAmount}
                      onChange={(e) => setCoverageAmount(e.target.value)}
                      className="slider-container"
                    />
                    <div className="slider-labels">
                      <span>₹50,000</span>
                      <span>₹1,000,000</span>
                    </div>
                    <div className="form-hint">Select the desired coverage amount</div>
                  </div>

                  <div className="form-field">
                    <label className="form-label">Plan Type</label>
                    <select
                      value={planType}
                      onChange={(e) => setPlanType(e.target.value)}
                      className="dropdown-select"
                    >
                      <option value="Standard">Standard</option>
                      <option value="Premium">Premium</option>
                      <option value="Gold">Gold</option>
                    </select>
                    <div className="form-hint">Select the type of insurance plan</div>
                  </div>
                </form>

                {/* Results Container */}
                <div className="results-container">
                  <div className="result-primary">
                    <div className="typography-container">Monthly Premium</div>
                    <div className="result-value">₹1,125</div>
                    <div className="result-hint">Estimated Monthly Premium</div>
                  </div>
                  <div className="result-secondary">
                    <div className="typography-container">Annual Premium</div>
                    <div className="result-value">₹13,500</div>
                    <div className="result-hint">Estimated Annual Premium</div>
                  </div>
                  <button className="get-quote-btn">Get a Quote</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="rider-card p-none">
        <RiderCard/>
      </div>
    </>
  );
};

export default HealthInsuranceCalculator;
